var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_c('div', {
    staticClass: "Polaris-EmptyState__Section"
  }, [_c('div', {
    staticClass: "Polaris-EmptyState__DetailsContainer"
  }, [_c('div', {
    staticClass: "Polaris-EmptyState__Details"
  }, [_c('polaris-text-container', [(_vm.heading) ? _c('polaris-display-text', {
    attrs: {
      "size": "medium"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.heading) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.$slots.default) ? _c('div', {
    staticClass: "Polaris-EmptyState__Content"
  }, [_vm._t("default")], 2) : _vm._e()], 1), _vm._v(" "), (_vm.action) ? _c('div', {
    staticClass: "Polaris-EmptyState__Actions"
  }, [_c('polaris-button-group', [_c('polaris-button', {
    attrs: {
      "size": "large",
      "primary": "",
      "url": _vm.action.url,
      "accessibility-label": _vm.action.accessibilityLabel,
      "disabled": _vm.action.disabled,
      "destructive": _vm.action.destructive,
      "icon": _vm.action.icon
    },
    on: {
      "click": function($event) {
        _vm.handleAction(_vm.action)
      }
    },
    slot: "1"
  }, [_vm._v("\n                            " + _vm._s(_vm.action.content) + "\n                        ")]), _vm._v(" "), (_vm.secondaryAction) ? _c('polaris-button', {
    attrs: {
      "plain": "",
      "url": _vm.secondaryAction.url,
      "accessibility-label": _vm.secondaryAction.accessibilityLabel,
      "disabled": _vm.secondaryAction.disabled,
      "destructive": _vm.secondaryAction.destructive,
      "icon": _vm.secondaryAction.icon
    },
    on: {
      "click": function($event) {
        _vm.handleAction(_vm.secondaryAction)
      }
    },
    slot: "2"
  }, [_vm._v("\n                            " + _vm._s(_vm.secondaryAction.content) + "\n                        ")]) : _vm._e()], 1)], 1) : _vm._e()], 1)]), _vm._v(" "), (_vm.image) ? _c('div', {
    staticClass: "Polaris-EmptyState__ImageContainer"
  }, [_c('img', {
    staticClass: "Polaris-EmptyState__Image",
    attrs: {
      "src": _vm.image,
      "role": "presentation",
      "alt": "",
      "srcset": _vm.largeImage ? _vm.image + ' 568w,' + _vm.largeImage + ' 1136w' : '',
      "sizes": "largeImage ? (max-width: 568px) 60vw : ''"
    }
  })]) : _vm._e()])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b7c1a13a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7c1a13a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisEmptyState.vue
// module id = 190
// module chunks = 0